import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SupportProgressDialogComponent } from 'src/app/components/profile/support/support-progress-dialog/support-progress-dialog.component';
import { SupportsDialogComponent } from 'src/app/components/profile/support/supports-dialog/supports-dialog.component';
import {
  SupportGuideComponent,
  SupportGuideStep,
} from 'src/app/components/profile/support/support-guide/support-guide.component';
import { TicketApiService } from 'src/app/services/api/ticket-api.service';

@Component({
  selector: 'app-user-profile-support-page',
  templateUrl: './user-profile-support-page.component.html',
  styleUrls: ['./user-profile-support-page.component.scss'],
})
export class UserProfileSupportPageComponent implements OnInit, OnDestroy {
  index = 1;
  forms: any;
  loading = false;
  openList: any = [];
  openItem: any;
  platformInfo: any;
  problemInfo: any;
  ticket: any;

  @ViewChild(SupportGuideComponent) guide?: SupportGuideComponent;

  /** 新手引导步骤配置（高亮真实页面区域，自动演示时面板切换为假数据） */
  guideSteps: SupportGuideStep[] = [];

  /** 教程演示中：两个数据面板展示假数据，不请求真实接口 */
  guideMode = false;

  /** 演示数据：车票列表 */
  demoSeats: any[] = [
    {
      order: { platform_name: 'Netflix 高级版', order_id: 'DEMO-0001' },
      account: 'l***8@gmail.com',
      product_icon: '',
      workorders: [],
    },
    {
      order: { platform_name: 'Spotify Premium', order_id: 'DEMO-0002' },
      account: 'm***6@outlook.com',
      product_icon: '',
      workorders: [],
    },
    {
      order: { platform_name: 'ChatGPT Plus', order_id: 'DEMO-0003' },
      account: 't***1@gmail.com',
      product_icon: '',
      workorders: [{}],
    },
  ];

  /** 演示数据：问题分类树 */
  demoProblems: any[] = [
    {
      name: '账号与会员',
      items: [
        { id: 1, name: '密码错误或无法登录', short_desc: '可先获取一次最新登录信息', tag: 'fast' },
        { id: 2, name: '登录后提示没有会员', short_desc: '需要客服核验会员状态', tag: 'manual' },
        { id: 3, name: '需要验证码但无法完成', short_desc: '客服协助完成验证', tag: '' },
        { id: 4, name: '以上都不是', short_desc: '自行描述遇到的问题', tag: '' },
      ],
    },
    {
      name: '播放与设备',
      items: [
        { id: 5, name: '提示不属于同一家庭', short_desc: '可先查看同户处理方式', tag: 'fast' },
        { id: 6, name: '提示观看设备过多', short_desc: '可先检查设备占用', tag: 'fast' },
        { id: 7, name: '无法播放或出现错误代码', short_desc: '提供错误提示即可', tag: 'manual' },
      ],
    },
    {
      name: '订单与售后',
      items: [
        { id: 8, name: '付款后还没有收到账号', short_desc: '核对订单发放状态', tag: 'manual' },
        { id: 9, name: '续费后没有生效', short_desc: '核对续费记录', tag: 'manual' },
        { id: 10, name: '需要退款或更换产品', short_desc: '由客服进行人工审核', tag: 'manual' },
      ],
    },
  ];

  /** 演示数据：被选中的车票（用于第 2/3 步顶部上下文） */
  demoPlatform: any = {
    product_icon: '',
    order: { platform_name: 'Netflix 高级版', order_id: 'DEMO-0001' },
    platform_id: 1,
    bus_seat_id: 1,
    account: 'l***8@gmail.com',
  };

  /** 演示数据：被选中的问题（用于第 3 步） */
  demoIssue: any = {
    id: 1,
    name: '密码错误或无法登录',
    help_estimated_minutes: 2,
    ai_estimated_minutes: 1,
    ticket_estimated_minutes: 30,
    enable_help: true,
    enable_ai: true,
    enable_ticket: true,
  };

  private destroyed = false;

  constructor(
    private dialog: MatDialog,
    private api: TicketApiService,
    private host: ElementRef<HTMLElement>,
  ) {}

  ngOnInit(): void {
    this.findProblemTickets();
    this.buildGuideSteps();
    void this.tryStartGuide();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  back() {
    if (this.index === 4) {
      this.index = 1;
      return;
    }
    if (this.index === 2 || this.index === 3) {
      this.index--;
      return;
    }
  }

  checkForm() {
    this.dialog.open(SupportsDialogComponent, {
      data: Object.assign({}, this.forms),
      width: '800px',
      panelClass: 'app-dialog',
    });
  }

  checkFormDetail(id: number) {
    this.dialog.open(SupportProgressDialogComponent, {
      data: id,
      width: '665px',
      panelClass: 'app-dialog',
    });
  }

  change1(event: any) {
    this.index = 2;
    this.platformInfo = event;
  }

  change2(event: any) {
    this.index = 3;
    this.problemInfo = event;
  }

  change3(event: any) {
    this.index = 4;
    this.ticket = event;
  }

  async findProblemTickets() {
    try {
      this.loading = true;
      const r = await this.api.findProblemTickets('open');
      this.openList = r.data;
      this.forms = {
        open: this.openList,
        done: [],
      };
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  status(txt: string) {
    const m: any = {
      submitted: '已提交',
      processing: '处理中',
      waiting_confirmation: '待确认',
      done: '已完成',
    };
    return m[txt] || null;
  }

  // =============================================
  // 新手引导（游戏式教程）
  // =============================================

  private buildGuideSteps() {
    const q = (selector: string): HTMLElement | null =>
      this.host.nativeElement.querySelector(selector);

    this.guideSteps = [
      {
        title: '全新支持流程，几步搞定',
        text: '账号出问题不用再填复杂表单：<b>选账号 → 选问题 → 选处理方式</b>。<br><br>花 1 分钟，像玩新手教程一样熟悉一遍吧！',
        btn: '开始教程',
      },
      {
        title: '第 1 步：选择出问题的账号',
        text: '这里列出你的有效车票（教程中是<b>演示数据</b>）。<b>直接点击报错的车票</b>即可，无需填写账号密码，系统会自动识别你的身份。',
        btn: '下一步',
        target: () => q('.orders'),
        action: () => {
          // 自动演示：选中第一张演示车票，进入第 2 步
          this.change1(this.demoPlatform);
        },
      },
      {
        title: '第 2 步：选择遇到的问题',
        text: '从常见问题里选最接近的一项（教程中是演示数据）。<b>不少问题支持自助处理或 AI 客服</b>，不必直接排队等人工。',
        btn: '下一步',
        target: () => q('.issues'),
        action: () => {
          // 自动演示：选中第一个演示问题，进入第 3 步
          this.change2(this.demoIssue);
        },
      },
      {
        title: '第 3 步：选择处理方式',
        text: '按需选择<b>帮助中心 / AI 客服 / 提交工单</b>。<br><br>需要人工时直接提交工单，写清问题和截图，客服接到就能立刻排查。',
        btn: '下一步',
        target: () => q('.route-panel'),
        action: () => {
          // 演示完毕：退出演示模式，恢复真实数据，方便展示最后一步
          this.exitGuideDemo();
        },
      },
      {
        title: '第 4 步：随时查看进度',
        text: '提交后点这里进入<b>「我的工单」</b>查看进度，还可以直接在工单里补充文字或截图，<b>不用重复提交新工单</b>。',
        btn: '完成，自由体验',
        target: () => q('.page-head .outline-btn'),
      },
    ];
  }

  private async tryStartGuide() {
    try {
      // 等页面主数据加载完成、引导组件绑定就绪，保证目标区域已渲染
      await this.waitFor(() => !this.loading && !!this.guide, 8000);
      if (this.destroyed) {
        return;
      }
      // 小屏上镂空高亮体验不佳，暂不自动弹出（要完全放开可删掉这两行）
      if (window.innerWidth < 768) {
        return;
      }
      // 规则：只有后端明确返回 completed === true 才不展示；false 或接口异常都展示
      let completed = false;
      try {
        const r: any = await this.api.getSupportGuideStatus();
        completed = !!(
          r &&
          r.status === 0 &&
          r.data &&
          r.data.completed === true
        );
      } catch (e) {
        completed = false;
      }
      if (completed) {
        return;
      }
      if (this.destroyed) {
        return;
      }
      await this.sleep(400);
      if (this.destroyed) {
        return;
      }
      // 进入演示模式：面板切换为假数据，再开始引导
      this.guideMode = true;
      this.guide?.start();
    } catch (e) {
      console.warn('[support-guide] 引导启动异常（不影响页面使用）', e);
    }
  }

  /**
   * 教程最后一步点击“完成”：调用后端接口标记完成，下次进入页面就不再展示。
   */
  onGuideFinished() {
    this.api.completeSupportGuide().catch(() => {});
    this.exitGuideDemo();
  }

  /** 用户中途按 Esc 跳过：不标记完成，同样恢复真实数据 */
  onGuideDismissed() {
    this.exitGuideDemo();
  }

  /** 退出演示模式：恢复真实数据与初始步骤 */
  private exitGuideDemo() {
    this.guideMode = false;
    this.index = 1;
    this.platformInfo = null;
    this.problemInfo = null;
    this.ticket = null;
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

  private sleep(ms: number): Promise<void> {
    return new Promise<void>((resolve) => setTimeout(resolve, ms));
  }

  private async waitFor(fn: () => boolean, timeoutMs: number): Promise<void> {
    const start = Date.now();
    while (!fn()) {
      if (Date.now() - start > timeoutMs) {
        return;
      }
      await this.sleep(100);
    }
  }
}
